import { STATUS_COLORS } from '../config/kpi';
import type { KpiStatus } from '../types/bsc';

interface StatusBadgeProps {
  status: KpiStatus;
  compact?: boolean;
}

export function StatusBadge({ status, compact = false }: StatusBadgeProps) {
  return (
    <span
      className={`status-badge${compact ? ' status-badge--compact' : ''}`}
      style={{ backgroundColor: STATUS_COLORS[status] }}
    >
      {status}
    </span>
  );
}
